import { createApiClient } from "../apiService";
import { app_languageTypes } from "./app_languageTypes";

const apiClient = createApiClient("dimension");

const handleResponse = <T>(response: any): T => {
  return response.data;
};

const getAppLanguages = async (): Promise<app_languageTypes[]> => {
  const response = await apiClient.get<app_languageTypes[]>("/language");
  return handleResponse(response);
};

const app_languageService = {
  getAppLanguages,
};

export default app_languageService;
